import AppFav from '../app-fav'

export default
{
    components:
    {
        AppFav
    },

    props:
    {
        content: { type: Array, default: null }
    },

    data()
    {
        return {
            cols: [[], []]
        }
    },

    mounted()
    {
        let totalHeight = 0

        this.content.forEach((l) =>
        {
            totalHeight += l.sizes['medium_large-height']
        })

        let currHeight = 0

        for(let i = 0; i < this.content.length; i++)
        {
            currHeight += this.content[i].sizes['medium_large-height']

            if(currHeight <= (totalHeight + 140) / 2)
            {
                this.cols[0].push(this.content[i])
            }
            else
            {
                this.cols[1].push(this.content[i])
            }
        }
    },

    methods:
    {
        onImageClick(index)
        {
            this.eventHub.$emit('toggle:modalProject', index, this.content)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-project-slideshow/script.js